/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithCycleCountItemRequestBuilder, WithCycleCountItemRequestBuilderRequestsMetadata } from './item';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /accounts/{accountId}/upcomingtransactions/{cycleIndex}
 */
export interface WithCycleIndexItemRequestBuilder extends BaseRequestBuilder<WithCycleIndexItemRequestBuilder> {
    /**
     * Gets an item from the MoneyChecker.Web.ApiClient.accounts.item.upcomingtransactions.item.item collection
     * @param cycleCount The number of cycles to retrieve transactions for (default is 1)
     * @returns {WithCycleCountItemRequestBuilder}
     */
     byCycleCount(cycleCount: number) : WithCycleCountItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const WithCycleIndexItemRequestBuilderUriTemplate = "{+baseurl}/accounts/{accountId}/upcomingtransactions/{cycleIndex}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithCycleIndexItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithCycleIndexItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byCycleCount: {
        requestsMetadata: WithCycleCountItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["cycleCount"],
    },
};
/* tslint:enable */
/* eslint-enable */
